import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export interface CustomTableTheme {
  container: {
    backgroundColor: string;
    borderColor: string;
  };
  header: {
    container: {
      backgroundColor: string;
      boxShadow: string;
    };
    cell: {
      backgroundColor: string;
      borderColor: string;
      textColor: string;
      iconColor: string;
    };
    checkbox: {
      backgroundColor: string;
      borderColor: string;
    };
  };
  row: {
    container: {
      backgroundColor: string;
      evenBackgroundColor: string;
      hoverBackgroundColor: string;
      selectedBackgroundColor: string;
      selectedBorderColor: string;
      selectedBorderRadius: string;
    };
    cell: {
      backgroundColor: string;
      borderColor: string;
      textColor: string;
    };
    checkbox: {
      backgroundColor: string;
      borderColor: string;
    };
    tag: {
      backgroundColor: string;
      hoverBackgroundColor: string;
      textColor: string;
    };
    modelIcon: {
      backgroundColor: string;
      textColor: string;
    };
    dropdownButton: {
      iconColor: string;
      hoverBackgroundColor: string;
    };
  };
  dropdown: {
    actions: {
      backgroundColor: string;
      borderColor: string;
    };
    columnPicker: {
      backgroundColor: string;
      borderColor: string;
    };
  };
  menu: {
    header: {
      textColor: string;
      borderColor: string;
    };
    item: {
      textColor: string;
      hoverBackgroundColor: string;
    };
    group: {
      textColor: string;
      borderColor: string;
    };
  };
}

export const customTableTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      container: {
        backgroundColor: theme.color.surface[0],
        borderColor: theme.color.surface[3],
      },
      header: {
        container: {
          backgroundColor: theme.color.surface[2],
          boxShadow: theme.color.neutral.grey.transparent['k-20%'],
        },
        cell: {
          backgroundColor: theme.color.surface[2],
          borderColor: theme.color.surface[3],
          textColor: theme.color.text.core['-secondary'],
          iconColor: theme.color.text.core['-primary'],
        },
        checkbox: {
          backgroundColor: theme.color.surface[1],
          borderColor: theme.color.surface[3],
        },
      },
      row: {
        container: {
          backgroundColor: theme.color.grid.base,
          evenBackgroundColor: theme.color.grid.stripe,
          hoverBackgroundColor: theme.color.grid.hover,
          selectedBackgroundColor: theme.color.grid.select,
          selectedBorderColor: theme.color.focus[4],
          selectedBorderRadius: '2px',
        },
        cell: {
          backgroundColor: 'transparent',
          borderColor: theme.color.surface[3],
          textColor: theme.color.text.core['-primary'],
        },
        checkbox: {
          backgroundColor: theme.color.surface[1],
          borderColor: theme.color.surface[3],
        },
        tag: {
          backgroundColor: theme.color.surface[2],
          hoverBackgroundColor: theme.color.focus[5],
          textColor: theme.color.text.core['-secondary'],
        },
        modelIcon: {
          backgroundColor: theme.color.lighting['ai-teal-halftone'],
          textColor: theme.color.text.core['-primary'],
        },
        dropdownButton: {
          iconColor: theme.color.text.core['-tertiary'],
          hoverBackgroundColor: theme.color.surface[1],
        },
      },
      dropdown: {
        actions: {
          backgroundColor: theme.color.surface[1],
          borderColor: theme.color.surface[3],
        },
        columnPicker: {
          backgroundColor: theme.color.surface[0],
          borderColor: theme.color.surface[3],
        },
      },
      menu: {
        header: {
          textColor: theme.color.text.core['-tertiary'],
          borderColor: theme.color.surface[3],
        },
        item: {
          textColor: theme.color.text.core['-primary'],
          hoverBackgroundColor: theme.color.surface[2],
        },
        group: {
          textColor: theme.color.text.core['-tertiary'],
          borderColor: theme.color.surface[3],
        },
      },
    },
  ]),
);
